export const getters = {
    getInstruments: state => state.instrumentsArray,
    getInstrumentInsert: state => state.instrumentInsert,
    getInstrumentDelete: state => state.instrumentDelete,
    getInstrumentUpdate: state => state.instrumentUpdate,
    getInstrumentMessage: state => state.instrumentMessageArray
}